<template>
  <div class="bg">
    <div class="login-panel">
      <span class="title">欢迎登陆八爪鱼客户管理系统</span>
      <form v-if="!showNext" @submit.prevent="next">
        <input v-model="username" type="text" class="input mb-3" placeholder="请输入账号" name="username">
        <div class="mb-3 r-group">
          <label><input v-model="item.type" type="radio" value="email" name="type">邮箱接收验证码</label>
          <label class="end"><input v-model="item.type" type="radio" value="sms" name="type">短信接收验证码</label>
        </div>
        <div ref="vaptcha1" style="width: 100%;height: 36px;margin-bottom: 10px;">
          <div class="vaptcha-init-main">
            <div class="vaptcha-init-loading">
              <a href="/" target="_blank">
                <img src="https://r.vaptcha.com/public/img/vaptcha-loading.gif" />
              </a>
              <span class="vaptcha-text">Vaptcha启动中...</span>
            </div>
          </div>
        </div>
        <button class="info mb-3" type="submit" block :disabled="!btnNextDisabled">下一步</button>
      </form>
      <form v-else @submit.prevent="resetPwd">
        <input v-model="item.code" type="text" class="input mb-3" placeholder="请输入验证码" name="item.code">
        <input v-model="item.password" type="text" class="input mb-3" placeholder="请输入密码" name="item.password">
        <div v-if="showVaptcha2" ref="vaptcha2" style="width: 100%;height: 36px;margin-bottom: 10px;">
          <div class="vaptcha-init-main">
            <div class="vaptcha-init-loading">
              <a href="/" target="_blank">
                <img src="https://r.vaptcha.com/public/img/vaptcha-loading.gif" />
              </a>
              <span class="vaptcha-text">Vaptcha启动中...</span>
            </div>
          </div>
        </div>
        <button class="info mb-3" type="submit" block :disabled="!btnResetDisabled">重置密码</button>
      </form>

      <button outline @click="btnForgetClicked">{{ btnForgetText }}</button>
    </div>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapActions} from 'vuex';

  export default {
    name: 'ResetPasswordForm',
    computed: {
      btnNextDisabled() {
        return this.username !== '';
      },
      btnResetDisabled() {
        return this.item.code !== '' && this.rules.length8(this.item.password)
      }
    },
    data: () => ({
      rules: {
        length8: value => (!!value && value.length >= 8),
        phoneNumber: value => {
          const pattern = /^1\d{10}$/;
          return pattern.test(value);
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value);
        }
      },
      //morsms: '',
      username: '',
      item: {
        type:'email'
      },
      showNext: false,
      RECAPTCHA: null,
      btnForgetText: '返回登录',
      vaptchaObj1: null,
      vaptchaObj2: null,
      showVaptcha2: false
    }),
    methods: {
      ...mapActions(['setError']),
      btnForgetClicked() {
        this.$router.push({
          name: 'login'
        });
      },
      next() {
        let response = this.vaptchaObj1.getToken();

        if (response && response !== '') {
          axios
            .post("/users/" + this.username + "/password", this.item, {
              headers: {
                'g-recaptcha-response': response
              },
              withCredentials: true
            })
            .then(response => {
              this.showNext = true;
            })
            .catch((reason) => {
              this.vaptchaObj1.reset();
              this.setError(reason.response.data.message);
            });
        } else {
          this.setError('验证有误');
        }
      },
      resetPwd() {
        let header = null;
        if (this.RECAPTCHA === 'RECAPTCHA') {
          let response = this.vaptchaObj2.getToken();
          header = {
            headers: {
              'g-recaptcha-response': response
            },
            withCredentials: true
          };

          if (response && response !== '') {
            //可以继续
          } else {
            this.setError('验证有误');
            return;
          }
        }

        axios
          .post("/users/" + this.username + "/password", this.item, header)
          .then(response => {
            this.RECAPTCHA = null;
            this.$router.push({
              name: 'login',
              params: {message: '重置密码成功'}
            });
          })
          .catch((reason) => {
            if (reason.response.data.message === 'RECAPTCHA') {
              //加验证
              this.RECAPTCHA = 'RECAPTCHA';
              this.showVaptcha2 = true;
              setTimeout(() => {
                window.vaptcha({
                  vid: '5df151acca7dd34ba15499d6',
                  type: 'click',
                  scene: '2',
                  container: this.$refs.vaptcha2,
                  offline_server: process.env.VUE_APP_API + 'vaptcha/offline'
                }).then(obj => {
                  obj.render();
                  this.vaptchaObj2 = obj;
                });
              }, 1000);
            }
            this.setError('验证有误');
          });
      },
      renderGrecaptcha() {
        window.vaptcha({
          vid: '5df151acca7dd34ba15499d6',
          type: 'click',
          scene: '2',
          container: this.$refs.vaptcha1,
          offline_server: process.env.VUE_APP_API + 'vaptcha/offline'
        }).then(obj => {
          obj.render();
          this.vaptchaObj1 = obj;
        });

      }
    },
    mounted() {
      this.renderGrecaptcha();
    }
  }
</script>

<style scoped>
  .bg {
    /*background: url('../assets/bg.png') center center;*/
    background-size: cover;
    width: 100%;
    height: 100vh;
  }

  .login-panel {
    width: 88%;
    height: 402px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    position: absolute;
    top: 50%;
    margin-top: -201px;
    left: 50%;
    padding: 30px 20px;
    margin-left: -44%;
  }

  .title {
    font-weight: 400;
    color: rgba(32, 133, 245, 1);
    line-height: 30px;
    margin-bottom: 32px;
    text-align: justify;
    text-justify: distribute-all-lines; /*ie6-8*/
    text-align-last: justify; /* ie9*/
    -moz-text-align-last: justify; /*ff*/
    -webkit-text-align-last: justify; /*chrome 20+*/
    width: 100%;
    display: block;
  }

  form {
    width: 100%;
  }
  form .r-group{
    display: flex;
  }

  form .r-group label{
    font-size: 14px;
    display: flex;
    align-items: center;
    flex: 1;
  }
  form .r-group label.end{
    justify-content: center;
  }

  .vaptcha-init-main {
    display: table;
    width: 100%;
    height: 100%;
    background-color: #EEEEEE;
  }

  .vaptcha-init-loading {
    display: table-cell;
    vertical-align: middle;
    text-align: center
  }

  .vaptcha-init-loading>a {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: none;
  }

  .vaptcha-init-loading>a img {
    vertical-align: middle
  }

  .vaptcha-init-loading .vaptcha-text {
    font-family: sans-serif;
    font-size: 12px;
    color: #CCCCCC;
    vertical-align: middle
  }
</style>
